import React from 'react';
import { Box, Theme, Grid, Typography, Divider, TextField } from '@material-ui/core';
import { useFormikContext } from 'formik';
import { Select } from '@campfire/select';
import { MultiSelect } from '@campfire/multi-select';
import { makeStyles, createStyles } from '@material-ui/styles';
import { CreatWidgetFormValues, rangeList } from '../../dashboard-widget-model';
import { useCampfireTheme } from '../../../../../../../../theme/useCampfireTheme';
import { useWidgetContextForm } from '../../useWidgetContextForm';
import { useApplyCustomWords } from '../../../useCustomWords';
import { SelectedValues } from '../SelectedValues';
import { FieldValueFilters, useFieldValueScope } from '../FieldValueFilters';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      color: theme.color.grey.neutral500,
      fontWeight: 700,
      fontSize: '18px',
      marginBottom: '8px',
    },
    label: {
      fontSize: '14px',
      fontWeight: 700,
      color: theme.color.grey.neutral500,
      paddingBottom: '6px',
    },
    valueItem: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: '56px',
      borderRadius: '6px',
      marginTop: '-8px',
      padding: '0 16px',
      cursor: 'pointer',
      position: 'relative',

      border: `1px solid ${theme.color.grey.neutralBrand200}`,
    },
  })
);

export const CustomMultiplierNumberWidgetForm = () => {
  const cw = useApplyCustomWords();
  const { theme } = useCampfireTheme();
  const classes = useStyles();
  const { setFieldValue, handleChange } = useFormikContext<CreatWidgetFormValues>();
  const { programs, activities, activityTags } = useWidgetContextForm();
  const { showPrograms, showActivities } = useFieldValueScope();

  return (
    <Grid container direction='column' style={{ width: '100%', marginBottom: '16px' }}>
      <Grid item xs={12}>
        <Typography className={classes.title}>Filtering</Typography>
        <Grid container spacing={3}>
          {showPrograms && (
            <Grid item xs={6}>
              <Typography className={classes.label}>{cw('Programs')}</Typography>
              <MultiSelect
                variant='outlined'
                name='programIds'
                label={cw('Select program/s')}
                placeholder={cw('All Programs')}
                items={programs}
                style={{ borderRadius: '8px' }}
              />
            </Grid>
          )}
          {showActivities && (
            <Grid item xs={6}>
              <Typography className={classes.label}>{cw('Activities')}</Typography>
              <MultiSelect
                variant='outlined'
                name='activityIds'
                label={cw('Select activity/activities')}
                placeholder={cw('All Activities')}
                items={activities}
                style={{ borderRadius: '8px' }}
              />
            </Grid>
          )}
          {showActivities && (
            <Grid item xs={6}>
              <Typography className={classes.label}>{cw('Activity Tags')}</Typography>
              <MultiSelect
                variant='outlined'
                name='tagIds'
                placeholder={cw('All Activity Tags')}
                label='Select tag/s'
                items={activityTags}
                style={{ borderRadius: '8px' }}
              />
            </Grid>
          )}
          <FieldValueFilters labelClassName={classes.label} />
        </Grid>
      </Grid>
      <Box my={3}>
        <Divider />
      </Box>
      <Grid item xs={12}>
        <Typography className={classes.title}>Range</Typography>
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <Typography className={classes.label}>Range</Typography>
            <Select
              fullWidth
              name='range'
              variant='outlined'
              items={rangeList}
              renderFunction={(item) => item.label}
              valueFunction={(item) => item.value}
              InputProps={{
                style: { borderRadius: '8px', color: theme.color.grey.neutral300 },
              }}
              onChange={handleChange}
            />
          </Grid>
        </Grid>
      </Grid>
      <Box my={3}>
        <Divider />
      </Box>
      <Grid item xs={12}>
        <Typography className={classes.title}>Custom</Typography>
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <Typography className={classes.label}>Custom Multiplier</Typography>
            <TextField
              fullWidth
              name='customMultiplier'
              variant='outlined'
              type='number'
              onChange={(e) => setFieldValue('customMultiplier', parseFloat(e.target.value))}
              InputProps={{
                style: { borderRadius: '8px', color: theme.color.grey.neutral300 },
              }}
            />
          </Grid>
        </Grid>
        <Box mt={3} mb={1.5}>
          <Divider />
        </Box>
      </Grid>
      <SelectedValues maxValue={1} />
    </Grid>
  );
};
